import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import styled from 'styled-components'

import { Colors } from '../../theme/colors'
import { header3, label3 } from '../../theme/typography'

export const StyledCheckbox = styled(Checkbox)<{ $error: boolean | undefined }>`
  &.MuiIconButton-root {
    background-color: transparent !important;
  }

  .MuiSvgIcon-root {
    fill: ${Colors.lightGray3};
  }

  &:hover .MuiSvgIcon-root,
  &.Mui-checked .MuiSvgIcon-root {
    fill: ${Colors.cyan};
  }

  .MuiSvgIcon-root,
  &.Mui-checked .MuiSvgIcon-root {
    ${({ $error }) =>
      $error && `fill: ${Colors.errorD1}; background-color: ${Colors.errorL1}; border-radius: 12px;`}
  }
`

export const FormControlLabelStyled = styled(FormControlLabel)`
  margin: 5px 0;
  margin-left: -10px;
  display: flex;
  align-items: flex-start;
  height: auto;

  .MuiTypography-body1 {
    ${header3};
    color: ${Colors.midGray};
    margin-top: 4px;
    font-weight: 400;
    padding-top: 7px;
  }
`

export const ErrorMessage = styled.div`
  ${label3};
  color: ${Colors.errorD1};
  margin-top: 5px;
  margin-left: 32px;
`
